import { useRouter } from 'next/router';

import { useGetPaginateOtcMedicineProducts } from '@api/product/productApis.rq';
import PlpVerticalCard from '@com/shared/cards/plpCard/vertical';
import OtcPlpVerticalCardShimmer from '@com/shared/cards/plpCard/verticalPlpCards/otcPlpVeticalCardShimmer';
import Pagination from '@com/shared/ocs/Pagination';
import { pickApiQuery, OTC_PLP_API_KEYS } from '@utilities/catalog/apiQuery';
import {
  buildPdpPath,
  DEFAULT_CATALOG_PAGE_SIZE,
  getProductId,
} from '@utilities/catalog/paths';
import { firstNumericParam } from '@utilities/http/firstParam';

type ProductsProps = {
  categoryCodeLevel1?: string;
};

const Products = ({ categoryCodeLevel1 }: ProductsProps) => {
  const { query } = useRouter();
  const pageSize =
    firstNumericParam(query.pageSize as string | string[], DEFAULT_CATALOG_PAGE_SIZE) ??
    DEFAULT_CATALOG_PAGE_SIZE;
  const apiQuery = pickApiQuery(
    query,
    {
      categoryCodeLevel1,
      pageNumber:
        firstNumericParam(query.pageNumber as string | string[], 1) ?? 1,
      pageSize,
    },
    { allowKeys: OTC_PLP_API_KEYS },
  );

  const { data, isLoading } = useGetPaginateOtcMedicineProducts(apiQuery);
  const lastPage = Math.max(
    1,
    Math.ceil((data?.totalCount || 0) / pageSize) || 1,
  );
  const isShownPagination = lastPage > 1;

  if (isLoading) {
    return (
      <div className="h-auto w-full grid grid-cols-2 gap-4 px-4 pb-4 pt-[8px]">
        {[...Array(8).keys()].map((item) => (
          <OtcPlpVerticalCardShimmer key={item} />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-4 pb-4">
      <div className="h-auto w-full grid grid-cols-2 gap-4 px-4 pt-[8px]">
        {data?.queryResult?.map((item, index) => (
          <PlpVerticalCard
            key={item.irc || item.genericCode}
            href={buildPdpPath(getProductId(item), item.productName)}
            type="otc"
            product={item}
            imagePriority={index < 2}
          />
        ))}
      </div>

      {isShownPagination ? <Pagination lastPage={lastPage} /> : null}
    </div>
  );
};

export default Products;
